import { Injectable, inject } from '@angular/core';
import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisSessionStorageService } from '../../core/service/base/his-session-storage.service';
import { HisSessionStorageKeys } from '../../core/model/his-session-storage-keys';

/**
 * Service that allows to navigate back to search(-result) page
 */
@Injectable({providedIn: 'root'})
export class HisSearchNavigationService {
    private readonly sessionStorageService = inject( HisSessionStorageService );
    private readonly navigationService = inject( HisNavigationService );

    /** Navigate to the new search URL @deprecated */
    public navigateToNewSearch( newSearchUrl: string ) {
        this.navigationService.navigateToUrl( newSearchUrl );
    }

    /** Navigate to the change search URL */
    public navigateToChangeSearch( changeSearchUrl: string ) {
        this.navigationService.navigateToUrl( changeSearchUrl );
    }

    public setSearchUrl( searchUrl: string ) {
        this.sessionStorageService.put( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL, searchUrl );
    }

    public clearSearchUrl() {
        this.sessionStorageService.put( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL, null );
    }

    private getPreviousSearchUrl(): string {
        return this.sessionStorageService.get( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL );
    }

    public hasPreviousSearchUrl(): boolean {
        return !!this.getPreviousSearchUrl();
    }

    public navigateToLastSearchUrl(): Promise<void> {
        const lastSearchUrl = this.getPreviousSearchUrl();
        if ( lastSearchUrl ) {
            return this.navigationService.navigateToUrl( lastSearchUrl );
        }
        console.error( 'HisSearchNavigationService: Navigation to last search form requested, but there was no previous search.' );
        return Promise.resolve();
    }

    public setSearchResultUrl( searchResultUrl: string ) {
        this.sessionStorageService.put( HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL, searchResultUrl );
    }

    public clearSearchResultUrl() {
        this.sessionStorageService.put( HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL, null );
    }

    public getPreviousSearchResultUrl(): string {
        return this.sessionStorageService.get( HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL );
    }

    public hasPreviousSearchResultUrl(): boolean {
        return !!this.getPreviousSearchResultUrl();
    }

    /** Navigates to the last search result, falling back to the last search form if there is none. */
    public navigateToLastSearchResultUrl(): Promise<void> {
        const url = this.getPreviousSearchResultUrl() || this.getPreviousSearchUrl();
        if ( url ) {
            return this.navigationService.navigateToUrl( url );
        }
        console.error( 'HisSearchNavigationService: Navigation to last search result requested, but there was no previous search.' );
        return Promise.resolve();
    }
}